export const MENU_LINKS = [
	{ name: 'ABOUT', link: '/' },
	{ name: 'PROJECTS', link: '/projects' },
	{ name: 'SKILLS', link: '/skills' },
];
